import React, { Component } from 'react'
import MovieTrack from './MovieTrack'
import './Movies.scss'





export default class Movies extends Component {

    state = {
        genre : [],
    }



    render() {
        return (
            <div className = "movies">
                
                <MovieTrack
                    genre = 'popular'
                    linkGenre = "https://api.themoviedb.org/3/movie/popular?api_key=21f53417a5404d2ee865b5d4641ec478&language=en-US&page=1"
                    genreList = {this.state.genre}
                />
                <MovieTrack
                    genre = 'Action'
                    linkGenre = "https://api.themoviedb.org/3/discover/movie?api_key=21f53417a5404d2ee865b5d4641ec478&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=28"
                    genreList = {this.state.genre}
                />
                <MovieTrack
                    genre = 'Adventure'
                    linkGenre = "https://api.themoviedb.org/3/discover/movie?api_key=21f53417a5404d2ee865b5d4641ec478&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=12"
                    genreList = {this.state.genre}
                />
                <MovieTrack
                    genre = 'Animation'
                    linkGenre = "https://api.themoviedb.org/3/discover/movie?api_key=21f53417a5404d2ee865b5d4641ec478&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=16"
                    genreList = {this.state.genre}
                />

            </div>
        )
    }

    componentDidMount() {
        const listGenreLink = "https://api.themoviedb.org/3/genre/movie/list?api_key=21f53417a5404d2ee865b5d4641ec478&language=en-US"

        fetch(listGenreLink)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    genre : data.genres,
                })
            })
    }
}
